import { Control, Controller } from "react-hook-form";
import { NewCustomer, UpdateCustomer } from "@vy/types";
import { FC } from "react";
import { TextField } from "@mui/material";
import { isNotNullOrUndefined } from "@vy/utils";

interface CustomerIdentifierTextInputProps {
    control: Control<NewCustomer | UpdateCustomer>
}

export const CustomerIdentifierTextInput: FC<CustomerIdentifierTextInputProps> = ({ control }) => (
    <Controller
        control={control}
        name="settings.cloudProviderSettings.customerIdentifier"
        render={({ field, fieldState }) => (
            <TextField
                {...field}
                fullWidth
                label="Customer Identifier"
                helperText={fieldState.error?.message}
                error={isNotNullOrUndefined(fieldState.error)}
            />
        )}
    />
)
